
export function mailGroupListGet(filter, page) {
	return {
    type: 'MAIL_GROUP_LIST_GET',
		payload: {
			filter: filter,
			page: page,
		},
	}
}

export function mailGroupItemConfirmed(pic) {
	return {
    type: 'MAIL_GROUP_ITEM_EDIT',
		payload: {
			type: 'confirmed',
			pic: pic,
		},
	}
}

export function mailGroupItemDel(pic) {
	return {
    type: 'MAIL_GROUP_ITEM_DEL',
		payload: {
			pic: pic,
		},
	}
}


export function mailGroupScrollPos(scrollPos) {
	return {
		type: "MAIL_GROUP_SCROLLPOS",
		payload: {
			scrollPos: scrollPos,
		},
	}
}
